import API from "../utils/api";
import { PlusLg, TicketDetailed, Search } from "react-bootstrap-icons";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Table,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Swal from "sweetalert";
import { useContext, useState, useEffect } from "react";
import "./Ventas.css";
import Error from "../Error";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { Container } from "react-bootstrap";
import swal from "sweetalert";
import { set } from "react-hook-form";

const NuevaVenta = () => {
  const navigate = useNavigate();
  const [Detalles, setDetalles] = useState([]);
  var url = API.urlAPI;
  const urlProductos = url + "productos";
  const urlCliente = url + "clientes";
  const urlModalidadPago = url + "modalidades-pago";
  const urlVentas = url + "ventas";

  const [error, setError] = useState(false);
  const [errorLista, setErrorLista] = useState(false);

  const [SelectProducto, setSelectProducto] = useState([]);
  const [Producto, setProducto] = useState("");

  const [clientes, setClientes] = useState([""]);
  const [modalidades, setModalidades] = useState([""]);
  const [selectCliente, setSelectCliente] = useState("");
  const [selectModalidadPago, setselectModalidadPago] = useState("");
  const [PrecioCosto, setPrecioCosto] = useState("");
  const [PrecioVenta, setPrecioVenta] = useState("");
  const [Cantidad, setCantidad] = useState("");
  const [Linea, setLinea] = useState(1);
  const [total, setTotal] = useState(0);
  const [interes, setInteres] = useState("");
  const [valorCuota, setValorCuota] = useState(0);
  const [totalConInteres, settotalConInteres] = useState(0);
  const [adelanto, setAdelanto] = useState(0);
  const [diasGracia, setDiasGracia] = useState("");
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [errorBotonList, setErrorBotonList] = useState(false);
  const [errorResumen, setErrorResumen] = useState(false);
  const [fecha, setFecha] = useState("");
  const [idVenta, setIdVenta] = useState("");
  const [MedioPago, setMedioPago] = useState("");

  useEffect(() => {
    const getData = async () => {
      const arr = [];
      await axios.get(urlCliente).then((res) => {
        let result = res.data;
        result.map((user) => {
          return arr.push({
            value: user.IdCliente,
            label: user.Nombre + " " + user.Apellido,
          });
        });
        setClientes(arr);
        console.log(arr);
      });
    };
    getData();
  }, []);

  useEffect(() => {
    const getModalidad = async () => {
      const arr = [];
      await axios.get(urlModalidadPago).then((res) => {
        let result = res.data;
        result.map((user) => {
          return arr.push({ value: user.Dias, label: user.Descripcion });
        });
        setModalidades(arr);
      });
    };
    getModalidad();
  }, []);

  const mediosPagos = [
    { value: "TR", label: "Transferencia" },
    { value: "EF", label: "Efectivo" },
  ];

  useEffect(() => {
    const getProductos = async () => {
      const arr = [];
      await axios.get(urlProductos).then((res) => {
        let result = res.data;
        result.map((user) => {
          return arr.push({ value: user.IdProducto, label: user.Descripcion });
        });
        setSelectProducto(arr);
      });
    };
    getProductos();
  }, []);

  const reset = () => {
    setPrecioCosto("");
    setPrecioVenta("");
    setCantidad("");
    setProducto("");
    setCuota("");
    setDetalles("");
    setDiasGracia("");
    setInteres("");
    setAdelanto("");
  };

  const resetLista = () => {
    setPrecioCosto("");
    setPrecioVenta("");
    setCantidad("");
    setProducto("");
  };

  const CrearDetalles = () => {
    if ([selectCliente, selectModalidadPago, MedioPago].includes("")) {
      console.log(selectCliente.value);
      console.log(selectModalidadPago.value);
      setError(true);
    } else {
      setMostrarDetalle(true);
      setError(false);
      console.log(selectCliente.value);
      console.log(selectModalidadPago.value);
    }
  };

  const handleAddDetails = () => {
    console.log(
      Producto.value,
      Producto.label,
      PrecioCosto,
      PrecioVenta,
      Cantidad
    );
    if (
      [
        Producto.value,
        Producto.label,
        PrecioCosto,
        PrecioVenta,
        Cantidad,
      ].includes("")
    ) {
      setErrorLista(true);
    } else {
      const valores = [...Detalles];
      setLinea(Linea + 1);
      valores.push({
        Linea: Linea,
        IdProducto: Producto.value,
        Producto: Producto.label,
        PrecioCosto: PrecioCosto,
        PrecioVenta: PrecioVenta,
        Cantidad: Cantidad,
      });

      setTotal(total + PrecioVenta * Cantidad);
      setDetalles(valores);
      console.log(Detalles);
      setErrorLista(false);
      resetLista();
    }
  };

  const eliminarProducto = (id) => {
    console.log("Key; ", id);
    let listadetalles = Detalles.filter((p) => p.Linea != id);

    const sumar = listadetalles
      .map((saldo) => parseInt(saldo.PrecioVenta * saldo.Cantidad))
      .reduce((previous, current) => {
        return previous + current;
      }, 0);
    setTotal(sumar);
    settotalConInteres(Number((sumar * interes) / 100) + Number(sumar));
    console.log(total);
    console.log(listadetalles);
    console.log("Detalles: ", Detalles);
    setDetalles(listadetalles);
  };

  const [cuota, setCuota] = useState("");

  console.log("MOSTRARDETALLES", mostrarDetalle);
  const opcionesCuotas = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },
    { value: "32", label: "32" },
    { value: "33", label: "33" },
    { value: "34", label: "34" },
    { value: "35", label: "35" },
    { value: "36", label: "36" },
    { value: "37", label: "37" },
    { value: "38", label: "38" },
    { value: "39", label: "39" },
    { value: "40", label: "40" },
    { value: "180", label: "180" },
  ];

  const ChangeInteres = (e) => {
    console.log("e ", e.target.value);
    setInteres(e.target.value);
    settotalConInteres(Number((total * e.target.value) / 100) + Number(total));
    console.log("interes: ", interes);
    console.log("Total con interes: ", totalConInteres);
    if (cuota) {
      setValorCuota(
        (Number((total * e.target.value) / 100) + Number(total)) / Number(cuota)
      );
    }
  };

  const ChangeCuota = (e) => {
    console.log(e.value);
    setCuota(e.value);

    setValorCuota(totalConInteres / e.value);
  };


  const PostVenta = async () => {
    if (selectModalidadPago.value === 0) {
      if ([selectCliente.value, selectModalidadPago.value].includes("")) {
        setErrorResumen(true);
      } else {
        const requestOptions = {
          method: "POST",

          body: JSON.stringify({
            idCliente: selectCliente.value,
            Cliente: selectCliente.label,
            Modalidad: selectModalidadPago.value,
            ModalidadDescripcion: selectModalidadPago.label,
            medioPago: MedioPago.value,
            CantCuotas: 0,
            TasaInteres: 0,
            ImporteCuota: 0,
            ImporteVenta: total,
            ImporteTotal: total,
            PorcentajeInteres: 0,
            DiasdeGracia: 0,
            FechaAlta: fecha,
            detalleventas: [Detalles],
          }),
          headers: { "Content-type": "application/json; charset=UTF-8" },
        };
        await fetch(urlVentas, requestOptions)
          .then((response) => response.json())
          .then((data) => {
            console.log("RespuestaAPI: ", data);
            setIdVenta(data.Prestamo);
            console.log("IdVenta", data.Prestamo);
            swal({
              title: "Venta al contado creada correctamente!",
              icon: "success",
              showConfirmButton: false,
              timer: 4000,
            });
            reset();
            setModalConfirmar(!modalConfirmar);

            setErrorResumen(false);
            navigate("DetalleVenta/" + data.Prestamo);
          })

          .catch((err) => {
            console.log(err);
            swal({
              title: "Ocurrió un error, contactar con el administrador",
              icon: "error",
              showConfirmButton: false,
              timer: 4000,
            });
          });
      }
    } else {
      if (
        [
          selectCliente.value,
          cuota,
          interes,
          diasGracia,
        ].includes("")
      ) {
        setErrorResumen(true);
      } else {
        const requestOptions = {
          method: "POST",
          headers: { "Content-type": "application/json; charset=UTF-8" },
          body: JSON.stringify({
            idCliente: selectCliente.value,
            Cliente: selectCliente.label,
            Modalidad: selectModalidadPago.value,
            ModalidadDescripcion: selectModalidadPago.label,
            medioPago: MedioPago.value,
            CantCuotas: cuota,
            TasaInteres: interes,
            ImporteCuota: valorCuota,
            ImporteVenta: total,
            ImporteTotal: totalConInteres,
            adelanto: adelanto,
            DiasdeGracia: diasGracia,
            FechaAlta: fecha,
            detalleventas: [Detalles],
          }),
        };
        await fetch(urlVentas, requestOptions)
          .then((response) => response.json())
          .then((data) => {
            console.log("RespuestaAPI: ", data);
            setIdVenta(data.Prestamo);
            console.log("IdVenta", data.Prestamo);
            swal({
              title: "Venta con interes creada correctamente!",
              icon: "success",
              showConfirmButton: false,
              timer: 4000,
            });
            reset();
            setModalConfirmar(!modalConfirmar);
            setErrorResumen(false);
            navigate("DetalleVenta/" + data.Prestamo);
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Ocurrió un error, contactar con el administrador",
              icon: "error",
              showConfirmButton: false,
              timer: 4000,
            });
          });
      }
    }
  };

  const [modalConfirmar, setModalConfirmar] = useState(false);

  const AbrirResumen = () => {
    if (Detalles.length < 1) {
      setErrorBotonList(true);
    } else {
      setModalConfirmar(!modalConfirmar);
      setErrorBotonList(false);

    }
  };

  const [habilitarBoton, setHabilitarBoton] = useState(false)

  const DescuentoAdelanto = () => {
    settotalConInteres(Number(((total - adelanto) * interes) / 100) + Number(total - adelanto));
    setValorCuota(
      (Number(((total - adelanto) * interes) / 100) + Number(total - adelanto))/ Number(cuota)
    );
    setHabilitarBoton(true)
  }

  return (
    <Container>
      <Row>
        <Col>
          <Row className="mb-2">
            <Col>
              <Card>
                <CardHeader
                  style={{ backgroundColor: "#4e73df", color: "white" }}
                >
                  Cliente
                </CardHeader>
                <CardBody>
                  <Form.Group controlId="fecha">
                    <Form.Label>Fecha:</Form.Label>
                    <Form.Control
                      type="date"
                      value={fecha}
                      onChange={(e) => setFecha(e.target.value)}
                    />
                    <br></br>
                  </Form.Group>
                  <Form.Group as={Col} controlId="clientes">
                    <Select
                      className="input-cont"
                      placeholder="Cliente"
                      options={clientes}
                      isClearable={true}
                      isSearchable={true}
                      onChange={(e) => setSelectCliente(e)}
                    />
                    <br></br>
                  </Form.Group>
                  <Form.Group as={Col} controlId="modalidad">
                    <Select
                      className="input-cont"
                      placeholder="Modalidad de Pago"
                      options={modalidades}
                      isClearable={true}
                      isSearchable={true}
                      onChange={(e) => setselectModalidadPago(e)}
                    />
                  </Form.Group>

                  <br></br>
                  <Form.Group as={Col} controlId="medioPago">
                    <Select
                      className="input-cont"
                      placeholder="Medio de pago"
                      options={mediosPagos}
                      isClearable={true}
                      isSearchable={true}
                      onChange={(e) => setMedioPago(e)}
                    />
                    <br></br>
                  </Form.Group>
                  
                  <Button
                    color="secondary"
                    block
                    onClick={() => CrearDetalles()}
                  >
                    Añadir Detalles
                  </Button>
                  <br></br>
                  {error && (
                    <Error>
                      <p>
                        Para añadir detalles es necesario completar los campos
                        de cliente, modalidad y medio de pago
                      </p>
                    </Error>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader
                  style={{ backgroundColor: "#4e73df", color: "white" }}
                >
                  Detalle
                </CardHeader>
                {mostrarDetalle && (
                  <CardBody>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Producto</Label>
                          <Select
                            placeholder="IdProducto"
                            options={SelectProducto}
                            isSearchable={true}
                            value={Producto}
                            isClearable={true}
                            onChange={(e) => setProducto(e)}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Precio Costo</Label>
                          <Input
                            bsSize="sm"
                            value={PrecioCosto}
                            onChange={(e) => setPrecioCosto(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Precio Venta</Label>
                          <Input
                            bsSize="sm"
                            value={PrecioVenta}
                            onChange={(e) => setPrecioVenta(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Cantidad</Label>
                          <Input
                            bsSize="sm"
                            value={Cantidad}
                            onChange={(e) => setCantidad(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      variant="success"
                      style={{
                        border: "none",
                        borderRadius: "50%",
                        height: "45px",
                        width: "45px",
                      }}
                      onClick={() => handleAddDetails()}
                    >
                      <PlusLg size={20}></PlusLg>
                    </Button>
                    <br></br>
                    <br></br>
                    {errorLista && (
                      <Error>
                        <p>Todos los campos son requeridos</p>
                      </Error>
                    )}
                    <Row>
                      <Col>
                        <Table responsive striped size="sm">
                          <thead>
                            <tr>
                              <th></th>
                              <th>ID Procuto</th>
                              <th>Producto</th>
                              <th>Precio Compra</th>
                              <th>Precio Venta</th>
                              <th>Cantidad</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Detalles.length < 1 ? (
                              <tr>
                                <td colSpan="7">Sin productos</td>
                              </tr>
                            ) : (
                              Detalles.map((item) => (
                                <tr key={item.Linea}>
                                  <td>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() =>
                                        eliminarProducto(item.Linea)
                                      }
                                    >
                                      Eliminar
                                    </Button>
                                  </td>
                                  <td>{item.IdProducto}</td>
                                  <td>{item.Producto}</td>
                                  <td>{item.PrecioCosto}</td>
                                  <td>{item.PrecioVenta}</td>
                                  <td>{item.Cantidad}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                        <Button
                          color="secondary"
                          block
                          onClick={() => AbrirResumen()}
                        >
                          {" "}
                          Abrir Resumen
                        </Button>
                        <br></br>
                        {errorBotonList && (
                          <Error>
                            <p>Debe añadir detalles a la venta</p>
                          </Error>
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                )}

                <Modal isOpen={modalConfirmar}>
                  <ModalHeader
                    style={{ backgroundColor: "#4e73df", color: "white" }}
                  >
                    Resumen Venta
                  </ModalHeader>
                  <ModalBody>
                    <Card>
                      {selectModalidadPago.value === 0 ? (
                        <Form.Group as={Col} controlId="diasgracia">
                          <FloatingLabel
                            controlId="floatingTextarea5"
                            label="Total Detalle"
                          >
                            <Form.Control disabled value={total} />
                          </FloatingLabel>
                        </Form.Group>
                      ) : (
                        <Row>
                          <Col>
                            <br></br>
                            <Row>
                              <Col>
                                <Select
                                  className="input-cont"
                                  placeholder="Cantidad de Cuotas"
                                  options={opcionesCuotas}
                                  isSearchable={true}
                                  Inputvalue={cuota}
                                  onChange={(e) => ChangeCuota(e)}
                                />
                              </Col>
                            </Row>

                            <Form.Group as={Col} controlId="interescuota">
                              <Form.Label> </Form.Label>
                              <FloatingLabel
                                controlId="floatingTextarea4"
                                label="Interes Cuota"
                              >
                                <Form.Control
                                  type="number"
                                  onChange={(e) => ChangeInteres(e)}
                                  min="1"
                                />
                              </FloatingLabel>
                            </Form.Group>
                            
                            <Row>
                              <Col>
                              <Form.Group as={Col} controlId="interesatraso">
                              <Form.Label> </Form.Label>
                              <FloatingLabel
                                controlId="floatingTextarea4"
                                label="Adelanto"
                              >
                                <Form.Control
                                  type="number"
                                  onChange={(e) =>
                                    setAdelanto(e.target.value)
                                  }
                                  min="1"
                                />
                              </FloatingLabel>
                            </Form.Group>
                              </Col>
                              <Col>
                              <br></br>
                              
                              <Button disabled= {habilitarBoton} onClick={() => DescuentoAdelanto()}>Descontar</Button>
                             
                              </Col>
                            </Row>

                            
                            <Form.Group as={Col} controlId="diasgracia">
                              <Form.Label> </Form.Label>
                              <FloatingLabel
                                controlId="floatingTextarea5"
                                label="Días de Gracia"
                              >
                                <Form.Control
                                  type="number"
                                  min="1"
                                  onChange={(e) =>
                                    setDiasGracia(e.target.value)
                                  }
                                />
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} controlId="diasgracia">
                              <Form.Label> </Form.Label>
                              <FloatingLabel
                                controlId="floatingTextarea5"
                                label="ValorCuota"
                              >
                                <Form.Control disabled value={valorCuota} />
                              </FloatingLabel>
                            </Form.Group>

                            <Form.Group as={Col} controlId="diasgracia">
                              <Form.Label> </Form.Label>
                              <FloatingLabel
                                controlId="floatingTextarea5"
                                label="Total Detalle"
                              >
                                <Form.Control disabled value={total} />
                              </FloatingLabel>
                            </Form.Group>
                            <Form.Group as={Col} controlId="total">
                              <Form.Label> </Form.Label>
                              <FloatingLabel
                                controlId="floatingTextarea5"
                                label="Total Con Interes"
                              >
                                <Form.Control
                                  disabled
                                  value={totalConInteres}
                                />
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                    </Card>
                    <br></br>
                    {errorResumen && (
                      <Error>
                        <p>Debe completar todos los campos</p>
                      </Error>
                    )}
                  </ModalBody>

                  <ModalFooter>
                    <Button color="success" block onClick={() => PostVenta()}>
                      {" "}
                      Terminar Venta
                    </Button>
                    <Button
                      color="secondary"
                      block
                      onClick={() => AbrirResumen()}
                    >
                      {" "}
                      Cancelar{" "}
                    </Button>
                  </ModalFooter>
                </Modal>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default NuevaVenta;
